import { render, staticRenderFns } from "./AvulsoModal.vue?vue&type=template&id=66d21568&scoped=true"
import script from "./AvulsoModal.vue?vue&type=script&lang=js"
export * from "./AvulsoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d21568",
  null
  
)

export default component.exports